import { useEffect, useState } from 'react';

const SESSION_KEY = 'design_sandbox_authenticated';

export const usePasswordAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    // Check sessionStorage on initialization
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem(SESSION_KEY) === 'true';
    }
    return false;
  });

  useEffect(() => {
    // Sync with sessionStorage
    if (isAuthenticated) {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } else {
      sessionStorage.removeItem(SESSION_KEY);
    }
  }, [isAuthenticated]);

  const authenticate = (password: string): boolean => {
    const correctPassword = process.env.REACT_APP_SANDBOX_PASSWORD;

    // If no password is configured, allow access
    if (!correctPassword) {
      setIsAuthenticated(true);
      return true;
    }

    if (password === correctPassword) {
      setIsAuthenticated(true);
      return true;
    }

    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem(SESSION_KEY);
  };

  return {
    isAuthenticated,
    authenticate,
    logout,
  };
};
